<div *ngIf="!loading && (showPromotionsNotification || showUnreadInboxNotification)" class="col-7 col-3--md col-4--sm card-details__banner">
  <air-notification-banner
    *ngIf="showPromotionsNotification && promotionsBannerPageUrl"
    [pageUrl]="promotionsBannerPageUrl"
    [icon]="promotionsBannerIcon"
    [theme]="promotionsBannerTheme"
    [action]="'dashboard.banner.general.action' | translate"
    [userEventSource]="userEventSource"
  >
    <ng-container *ngIf="hasUpcomingExpiration">
      {{
        ("dashboard.banner.expiration.message-content" | translate).format([
          upcomingExpiration?.date | date: "dd-MM-yyyy",
          upcomingExpiration?.points
        ])
      }}
    </ng-container>
    <ng-container *ngIf="!hasUpcomingExpiration">
      {{
        (unactivatedPromotionsCount > 1
          ? "dashboard.banner.promotion.message-intro.plural"
          : "dashboard.banner.promotion.message-intro.single"
        ) | translate
      }}
      <span class="banner__message--highlight">
        {{ ("dashboard.banner.promotion.message-content" | translate).format([unactivatedPromotionsCount]) }}
      </span>
      {{
        (unactivatedPromotionsCount > 1
          ? "dashboard.banner.promotion.message-outro.plural"
          : "dashboard.banner.promotion.message-outro.single"
        ) | translate
      }}
    </ng-container>
  </air-notification-banner>
  <air-notification-banner
    *ngIf="!showPromotionsNotification && showUnreadInboxNotification && inboxPageUrl"
    [pageUrl]="inboxPageUrl"
    icon="icon-ui-mail"
    [theme]="bannerTheme.pink"
    [action]="'dashboard.banner.general.action' | translate"
    [userEventSource]="userEventSource"
  >
    {{ "dashboard.banner.inbox.message-intro" | translate }}
    <span class="banner__message--highlight">{{
      unreadInboxCount > 1
        ? ("dashboard.banner.inbox.new-message-plural" | translate: { count: unreadInboxCount })
        : ("dashboard.banner.inbox.new-message-single" | translate: { count: unreadInboxCount })
    }}</span>
    {{ "dashboard.banner.inbox.message-outro" | translate }}
  </air-notification-banner>
</div>
<div class="content-panel grid card-details" [class.loading]="loading">
  <div class="col-5 col-3--md col-4--sm card-details--my-card">
    <air-my-card
      *ngIf="isMobile"
      intersectionObserver
      [intersectionDebounce]="0"
      (visibilityChange)="onVisibilityChanged($event)"
      (click)="openCardSheet()"
    ></air-my-card>
    <air-my-card *ngIf="!isMobile"></air-my-card>
  </div>
  <div class="col-7 col-3--md col-4--sm card-details--overview card-details__spacer-promotions">
    <div class="card-details__current-summary" [class.d--flex]="isiOSMobile">
      <h5 class="card-details__heading">{{ "dashboard.label.current_balance" | translate }}</h5>
      <div class="card-details__item">
        <div class="card-details__label--amount">{{ loading ? 000 : (balance | formatNumber) }}</div>
        <div class="card-details__label">{{ "general.label.air_miles" | translate }}</div>
      </div>
    </div>
    <div class="card-details__past-summary">
      <h5 class="card-details__heading">{{ "dashboard.label.past_month" | translate }}</h5>
      <div class="card-details__items">
        <div class="card-details__item">
          <div class="card-details__label--amount">{{ loading ? 000 : (pointsEarned | formatNumber) }}</div>
          <div class="card-details__label">{{ "dashboard.label.earned" | translate }}</div>
        </div>
        <div class="card-details__item">
          <div class="card-details__label--amount">{{ loading ? 000 : (pointsSpent | formatNumber) }}</div>
          <div class="card-details__label">{{ "dashboard.label.spent" | translate }}</div>
        </div>
      </div>
    </div>
  </div>
</div>
